<template>
  <div>
    <v-layout column wrap>
      <v-card>
        <v-toolbar dense dark color="primary">
          <v-toolbar-title><h4 class="font-weight-light">ADMIN SHARE BREAKDOWN</h4>
          </v-toolbar-title>
        </v-toolbar>
        <v-data-table
          class="pt-6"
          :headers="headers"
          :items="list_of_loan_savings"
          :loading="data_table_loading"
          loading-text="Loading... Please wait"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <span class="headline">TOTAL: {{ total }}</span>
              <v-divider
                class="mx-4"
                inset
                vertical
              ></v-divider>
              <span
                v-if="list_of_loan_savings.length>0">
                                                Print Data
                                                <v-icon
                                                  class="mr-2"
                                                  color="warning"
                                                  @click="print()"
                                                >
                                                {{ icons.mdiPrinter }}
                                                </v-icon>
                                            </span>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td>
                {{
                  list_of_loan_savings
                    .map(function (x) {
                      return x.id
                    })
                    .indexOf(item.id) + 1
                }}
              </td>
              <td>
                {{
                  item.members.last_name + ', ' + item.members.first_name + ' ' + item.members.middle_name
                }}
              </td>
              <td>
                {{ item.or_date }}
              </td>
              <td>
                {{ item.amount }}
              </td>
              <td>
                {{ item.or_no }}
              </td>
            </tr>
          </template>
          </tr>
        </v-data-table>
      </v-card>
    </v-layout>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {mapActions} from 'vuex'
import {mdiAccountSearchOutline, mdiPrinter, mdiPencil} from '@mdi/js'
import moment from "moment";

export default {
  setup() {
    return {
      icons: {
        mdiAccountSearchOutline,
        mdiPrinter,
        mdiPencil,
      },
    }
  },
  data() {
    return {

      search: '',
      search_member: '',
      search_items: [],

      saving: false,
      alert: false,
      alert_message: '',

      or_date: '',
      or_no: '',
      amount: 0,
      no_of_share: 0,
      no_of_share_sub: 0,
      particulars: '',
      particulars_items: [],


      can_edit: false,
      selected_month_of: 'NA',
      category: '',
      month_of_items: [],
      selected_details: {},
      member_information: {},
      month_of: '',
      year_of_items: [],
      year_of: '',
      selectedDepositId: -1,
      list_of_loan_savings: [],
      total: 0,
      //table props
      data_table_loading: false,
      headers: [
        {text: 'No.', value: 'no'},
        {text: 'Name', value: 'full_name'},
        {text: 'Date', value: 'or_date'},
        {text: 'Amount', value: 'amount'},
        {text: 'OR#', value: 'or_no'},
      ],
    }
  },
  mounted() {
    this.get_list_of_coop_payable_summary_items()
  },
  computed: {
    ...mapGetters('form_rules', ['rules']),
    ...mapGetters('system_data', ['company_logo']),
    ...mapGetters('authentication', ['branch_id', 'branch', 'branch_address', 'branch_contact_no']),
  },
  watch: {
    branch_id: function () {
      this.can_print = false
      this.month_of = ''
      this.list_of_loan_savings = []
      this.total = '0'
      this.selected_month_of = 'NA'
    },
  },
  methods: {
    ...mapActions('system_data', ['change_snackbar']),
    ...mapActions('transaction_months', ['retrieve_transaction_month', 'retrieve_all_transaction_year']),
    ...mapActions('share_capital', ['admin_share_breakdown_from_declared_member']),
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    get_list_of_coop_payable_summary_items() {
      this.admin_share_breakdown_from_declared_member()
        .then((response) => {
          this.total = response.data.length
          this.list_of_loan_savings = response.data
          this.data_table_loading = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    print() {
      var imgData = this.company_logo
      var payments_array = []

      var month = this.selected_month_of
      var total = this.total
      var totalno_of_shares = 0
      var totalamount_subscribed = 0
      var totalno_of_shares_paid = 0
      var totalamount_paid_subscribed = 0
      payments_array.push(
        [
          {text: 'No.', alignment: 'center', style: 'label'},
          {text: 'Name', alignment: 'center', style: 'label'},
          {text: 'Date', alignment: 'center', style: 'label'},
          {text: 'Amount', alignment: 'center', style: 'label'},
          {text: 'Invoice #', alignment: 'center', style: 'label'},
        ]
      )
      if (this.list_of_loan_savings.length > 0) {
        this.list_of_loan_savings.forEach(function (item, index) {
          payments_array.push(
            [
              {text: index + 1, alignment: 'center'},
              {
                text: item.members.last_name + ', ' + item.members.first_name + ' ' + item.members.middle_name,
                alignment: 'left'
              },
              {text: item.or_date, alignment: 'left'},
              {text: item.amount, alignment: 'left'},
              {text: item.or_no, alignment: 'left'},
            ]
          )
        })
      } else {
        payments_array.push(
          [
            '----',
            '----',
            '----',
            '----',
            '----',
          ]
        )
      }
      //call pdfmake
      var pdfMake = require('pdfmake/build/pdfmake.js')
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require('pdfmake/build/vfs_fonts.js')
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
      var docDefinition = {
        pageSize: 'LETTER',
        content: [
          {
            columns: [
              {image: imgData, width: 54, height: 54, style: 'logo'},
              {
                stack: [
                  'GOODLIFE SAVINGS & CREDIT COOPERATIVE',
                  {
                    text: 'Ground Floor, GL Emerald Building San Jose Digos City Davao del Sur 8002',
                    style: 'subheader'
                  },
                  {
                    text: 'C.D.A. REG. No. 9520-1011000000048747 CONTACT NO.: ' + this.branch_contact_no,
                    style: 'subheader'
                  },
                ],
                style: 'header'
              },
            ]
          },
          {text: 'LIST OF SHARES BREAKDOWN', style: 'title'},
          '================================================================================',
          {text: 'Printed as of: ' + moment().format('MMMM D, YYYY'), style: 'printed_label'},
          ' ',
          {
            style: 'tableExample',
            color: '#444',
            table: {
              widths: [30, 200, 80, 80, 80, 80, 60, 40, 60],
              body: payments_array,
            },
            layout: {
              fillColor: function (rowIndex) {
                return (rowIndex === 0) ? '#CCCCCC' : null;
              },
            },
          },
        ],
        footer: {
          columns: [
            {
              text: 'Generated with Goodlife Savings & Credit Cooperative System',
              alignment: 'center',
              style: 'tableExample'
            }
          ]
        },
        styles: {
          header: {
            fontSize: 21,
            bold: true,
            alignment: 'left',
            margin: [6, 6, 0, 20]//[left, top, right, bottom]
          },
          subheader: {
            fontSize: 12
          },
          title: {
            fontSize: 15,
            alignment: 'center',
          },
          logo: {
            alignment: 'center',
            margin: [0, 0, 0, 0]//[left, top, right, bottom]
          },
          printed_label: {
            alignment: 'right',
            fontSize: 9,
            margin: [0, 4, 0, 0]//[left, top, right, bottom]
          },
          main_info: {
            margin: [0, 2, 0, 2],
            fontSize: 10,
          },
          sub_info: {
            margin: [0, 2, 0, 2],
            fontSize: 8,
          },
          tableExample: {
            fontSize: 9,
          },

          aa_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          cashier_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          bm_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          cs_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          aa_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cashier_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cs_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          bm_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          aa_placeholder: {
            margin: [15, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          aa_for: {
            margin: [0, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cs_for: {
            margin: [2, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cashier_for: {
            margin: [3, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          bm_for: {
            margin: [3, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cashier_placeholder: {
            margin: [26, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cs_placeholder: {
            margin: [2, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          bm_placeholder: {
            margin: [5, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          au_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          au_placeholder: {
            margin: [2, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          au_for: {
            margin: [2, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          au_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
        },
      }
      pdfMake.createPdf(docDefinition).open();
    },
  }
}
</script>
